import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import api from "../lib/api";
import { toast } from "sonner";
import { CheckCircle, Loader2, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const navigate = useNavigate();
  const { login } = useAuth();
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = setInterval(async () => {
      attempts++;
      try {
        const res = await api.get(`/checkout/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          clearInterval(poll);
          setStatus("success");
          toast.success("Pago completado correctamente");
        } else if (res.data.status === "expired" || attempts >= 10) {
          clearInterval(poll);
          setStatus("error");
        }
      } catch {
        if (attempts >= 10) { clearInterval(poll); setStatus("error"); }
      }
    }, 2000);
    return () => clearInterval(poll);
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="min-h-screen flex items-center justify-center" style={{ background: "#0B1622" }}>
      <div className="text-center max-w-md px-6">
        {status === "checking" && (
          <div className="animate-fade-in-up">
            <Loader2 className="w-16 h-16 mx-auto mb-4 animate-spin" style={{ color: "#00D4FF" }} />
            <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "'Space Grotesk'", color: "#E2E8F0" }}>Verificando pago...</h1>
            <p className="text-sm" style={{ color: "#94A3B8" }}>Estamos confirmando tu transacción</p>
          </div>
        )}
        {status === "success" && (
          <div className="animate-fade-in-up">
            <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ background: "rgba(74,222,128,0.1)" }}>
              <CheckCircle className="w-10 h-10" style={{ color: "#4ADE80" }} />
            </div>
            <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "'Space Grotesk'", color: "#E2E8F0" }}>Pago completado</h1>
            <p className="text-sm mb-8" style={{ color: "#94A3B8" }}>Tu plan se ha activado correctamente. Ya puedes generar artículos.</p>
            <Button data-testid="go-dashboard-btn" onClick={() => navigate("/dashboard")}
              className="rounded-full px-8 h-11 font-medium"
              style={{ background: "linear-gradient(135deg, #00B4D8, #00D4FF)", color: "#0B1622" }}>
              Ir al Panel
            </Button>
          </div>
        )}
        {status === "error" && (
          <div className="animate-fade-in-up">
            <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ background: "rgba(239,68,68,0.1)" }}>
              <XCircle className="w-10 h-10" style={{ color: "#ef4444" }} />
            </div>
            <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "'Space Grotesk'", color: "#E2E8F0" }}>Error en el pago</h1>
            <p className="text-sm mb-8" style={{ color: "#94A3B8" }}>No se pudo confirmar el pago. Inténtalo de nuevo.</p>
            <Button onClick={() => navigate("/pricing")} className="rounded-full px-8 h-11 font-medium"
              style={{ background: "rgba(0,212,255,0.15)", color: "#00D4FF" }}>
              Volver a Planes
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
